
/* injects from baggage-loader */

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { t } from "../../../../dev/helpers/translator";
import { OpenPopup } from "../../../actions/ui";
import Config from "../../../config/main";

const MarketsFilter = ({ game, marketsGroupsNames, marketsFilter, setMarketsFilter }) => {
	// const dispatch = useDispatch();
	// const [marketAll, otherMarkets] = useMemo(() => ([
	//     marketsGroupsNames.find(marketName => marketName === 'all'),
	//     marketsGroupsNames.filter(marketName => marketName !== 'all')
	// ]), [marketsGroupsNames]);
	const dispatch = useDispatch();
	const [marketAll, otherMarkets] = useMemo(() => {
		if (!marketsGroupsNames) return [[], []];

		const onlyAllAndOther = marketsGroupsNames.length === 2;

		if (onlyAllAndOther) return [null, []];

		return [
			marketsGroupsNames.find(marketName => marketName === "all"),
			marketsGroupsNames.filter(marketName => marketName !== "all"),
		];
	}, [marketsGroupsNames]);

	const betBuilderAvailable = Config.betting.enableBetBuilder && game?.sportcast_id;

	const openBetBuilder = () => {
		const popupData = {
			title: `${game.team1_name} vs ${game.team2_name}`,
			sportcastId: game.sportcast_id,
		};

		dispatch(OpenPopup("betBuilder", popupData));
	};

	return (
		<div className="time-filter-m game-markets-f">
			<ul>
				{marketAll && (
					<li
						className={marketsFilter === "all" ? "active" : ""}
						onClick={setMarketsFilter("all")}
					>
						{t("All")}
					</li>
				)}

				{betBuilderAvailable && <li onClick={openBetBuilder}>{t("Bet Builder")}</li>}

				{otherMarkets.map(marketName => (
					<li
						key={marketName}
						className={marketsFilter === marketName ? "active" : ""}
						onClick={setMarketsFilter(marketName)}
					>
						{marketName === "all" ? t("All") : t(marketName)}
					</li>
				))}
			</ul>
		</div>
	);
};

MarketsFilter.propTypes = {
	marketsGroupsNames: PropTypes.array,
	marketsFilter: PropTypes.string,
	setMarketsFilter: PropTypes.func,
};

export default MarketsFilter;
